import { TherapistAction, therapistDisciplineList } from './constant';

const {
  REQUEST_GET_ALL_THERAPIST,
  THERAPIST_AUTO_MATCHING_REQUEST,
  THERAPIST_DEFUALT_THERAPIST_REQUEST,
  THERAPIST_DEFAULT_THERAPIST_RESET,
  THERAPIST_AUTO_MATCHING_RESET,
  DISABLE_AUTO_MATCH_REQUEST,
} = TherapistAction;
const { GET_THERAPIST_DISCIPLINE_LIST_REQUEST } = therapistDisciplineList;

export const getAllTherapists = (payload: object) => {
  return {
    type: REQUEST_GET_ALL_THERAPIST,
    payload,
  };
};

export const getAllDisciplineTherapist = (payload: object) => {
  return {
    type: GET_THERAPIST_DISCIPLINE_LIST_REQUEST,
    payload,
  };
};
export const autoMatchingTherapistAction = (payload: object) => {
  return {
    type: THERAPIST_AUTO_MATCHING_REQUEST,
    payload,
  };
};
export const autoMatchingTherapistResetAction = () => {
  return {
    type: THERAPIST_AUTO_MATCHING_RESET,
  };
};
export const disableAutoMatchAction = (payload: object) => {
  return {
    type: DISABLE_AUTO_MATCH_REQUEST,
    payload,
  };
};
export const defaultTherapistTaskAction = (payload: object) => {
  return {
    type: THERAPIST_DEFUALT_THERAPIST_REQUEST,
    payload,
  };
};

export const resetDefaultTherapistAssignAction = () => {
  return {
    type: THERAPIST_DEFAULT_THERAPIST_RESET,
  };
};
